import customAxios, { ensureFreshToken } from "./axios";

/**
 * Opsi `channelAuthorization` Pusher yang auth channel private lewat customAxios.
 * Header statis di opsi `auth` Pusher akan usang setelah refresh token, jadi di sini
 * token di-refresh dulu jika hampir expired, dan 401 ikut alur refresh + retry.
 * @param {string} endpoint URL absolut endpoint broadcasting auth
 * @param {object} headers header tambahan (null = hapus header default customAxios)
 */
export const createChannelAuthorization = (endpoint, headers = {}) => ({
  customHandler: async ({ socketId, channelName }, callback) => {
    try {
      await ensureFreshToken();
      const { data } = await customAxios.post(
        endpoint,
        new URLSearchParams({ socket_id: socketId, channel_name: channelName }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...headers,
          },
          skipErrorNotification: true,
        }
      );
      callback(null, data);
    } catch (error) {
      callback(
        error instanceof Error ? error : new Error("Pusher channel auth failed"),
        null
      );
    }
  },
});
